import { motion } from "framer-motion";
import { useAuthStore } from "../../store/useAuthStore";

export const TopBar = () => {
  const { user, logout } = useAuthStore();
  return (
    <div className="fixed top-0 inset-x-0 z-50 px-6 py-5 pointer-events-none">
      <div className="glass rounded-[2rem] px-6 py-3 flex items-center justify-between shadow-2xl pointer-events-auto max-w-[1600px] mx-auto bg-black/40 backdrop-blur-2xl border border-white/10">
        
        <div className="flex items-center gap-4">
          <motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ type: "spring" }}>
            {/* Horizontal TopBar Logo Fix */}
            <div className="h-10 md:h-14 w-auto flex items-center justify-start">
                <img src="/brand-logo.png" alt="Logo" className="w-auto h-full object-contain object-left drop-shadow-xl" />
            </div>
          </motion.div>
        </div>
        
        <div className="flex items-center gap-6">
          <div className="text-sm font-medium text-white/50 hidden md:block tracking-wide">{user?.email}</div>
          <div className="relative group cursor-pointer" onClick={logout}>
            {user?.picture ? (
              <img src={user.picture} alt="Profile" className="w-12 h-12 md:w-14 md:h-14 rounded-full border-2 border-white/10 hover:border-electric transition-all shadow-lg" />
            ) : (
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-gradient-to-tr from-electric to-magenta flex items-center justify-center font-bold text-lg shadow-lg border-2 border-white/10 hover:border-white transition-all">
                {user?.name?.charAt(0) || "U"}
              </div>
            )}
            <div className="absolute right-0 top-[110%] opacity-0 group-hover:opacity-100 transition-opacity bg-red-500 text-white text-xs px-3 py-1.5 rounded-lg font-bold shadow-xl pointer-events-none whitespace-nowrap">
              Log out
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
